import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service';
import { UserService} from '../service/user.service';
import { BusyProvider } from '../service/busy.service';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, User, UserStatisticsProspectResponse, UserStatisticsProspect, UserInfo } from '../core/core.component';
import { SelectItem } from 'primeng/primeng';

import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-users-prospect',
  templateUrl: './users-prospect.component.html',
  styleUrls: ['./users-prospect.component.css']
})
export class UsersProspectComponent extends BaseComponent implements OnInit 
{
    userContext: UserContext;
    userInfo: UserInfo = new UserInfo();
    months: SelectItem[] = [];
    monthSelected: number = 0;
    years: SelectItem[] = [];
    yearSelected: number = 0;
    prospects: UserStatisticsProspect[] = [];
    completed: boolean = true;
    
    gruppiDropdownVisibile: boolean=false;
    users: User[] = [];
    selectedGruppo: number = 0;
    gruppiUsers: SelectItem[] = [];
    gruppi: SelectItem[]=[];
    utentiVisibili: SelectItem[]=[];
    filterUsernames: SelectItem[]=[];
    numgruppi: number = null;
    managedUsers: SelectItem[]=[];
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider,
            private userService: UserService, 
            private busyProvider: BusyProvider,
            private datePipe: DatePipe) 
    { 
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
    }


  ngOnInit() 
  {
      this.userContext = this.authAccess.getUserContext();
      if (this.userContext == null) {    
          this.authAccess.invalidate();
      } else {
          this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
            result => {
                this.userInfo = result;
          },
          error => {
              this.handleError(error);
          });
          
          let previousMonth : Date = new Date();
          let year = previousMonth.getFullYear();
          
          for (let i = -5; i < 2; i++) { // da anno corrente -5 ad anno corrente +1
            this.years.push({label: (year + i) + '', value: year + i});
          }
          if(previousMonth.getMonth() > 0) {
              previousMonth.setMonth(previousMonth.getMonth() - 1, 1);
          } else {
              previousMonth.setFullYear((year-1), 11, 1);
          }
          this.months.push({label: "Gennaio", value: 0});
          this.months.push({label: "Febbraio", value: 1});
          this.months.push({label: "Marzo", value: 2});
          this.months.push({label: "Aprile", value: 3});
          this.months.push({label: "Maggio", value: 4});
          this.months.push({label: "Giugno", value: 5});
          this.months.push({label: "Luglio", value: 6});
          this.months.push({label: "Agosto", value: 7});
          this.months.push({label: "Settembre", value: 8});
          this.months.push({label: "Ottobre", value: 9});
          this.months.push({label: "Novembre", value: 10});
          this.months.push({label: "Dicembre", value: 11});    
     
          this.monthSelected = previousMonth.getMonth();
          this.yearSelected = previousMonth.getFullYear();

          this.userService.getUsers(this.userContext.srmToken, false).
          subscribe(
              result => {
                  
                  this.users = result.users;
                  for (var i = 0; i < result.users.length; ++i) {
                      var current: User = result.users[i];
                      
                      if (this.userInfo.admin || this.userInfo.managedUsers.indexOf(current.username.toLowerCase()) != -1) {
                          this.filterUsers.push({ label: current.fullname, value: current.id });
                          this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id});
                          this.filterUsernames.push({ label: current.username, value: current.id });
                          
                      }
                  }
                  
                  for (var i = 0; i < this.filterUsers.length; i++) {
                              
                          if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase())))
                              this.managedUsers.push(this.filterUsers[i]);
                  }

                  this.gruppi=[];
                  this.numgruppi=0;
                      this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                      for (const key in this.userInfo.managedUsersMap) {
                          this.numgruppi++;
                          this.gruppi.push({ label: key, value: this.numgruppi });
                      }
              },
              error => {
                  this.handleError(error);
              });

      }
  }
  
  calculate()
  {
      this.gruppiDropdownVisibile=true;
      this.completed = false;
      let resp : UserStatisticsProspectResponse = null;
      this.userService.getUserProspects(this.userContext.srmToken, this.monthSelected, this.yearSelected).subscribe(
           result => {
               resp = result;
               this.prospects = resp.prospects;
               this.completed = true;
           },
           error => {
              this.completed = true;
              this.handleError(error);
           }
      );
  }
  
  scarica()
  {
      this.messageProvider.clearAll();
      this.busyProvider.showBusyIndicator();
      this.userService.downloadUserProspects(this.userContext.srmToken, this.monthSelected, this.yearSelected).subscribe(
              data => {
                  this.busyProvider.hideBusyIndicator();
                  this.downloadFile(data);
              },
              error => {
                  this.busyProvider.hideBusyIndicator();
                  // nei report ci si aspetta un blob pertanto gli eventuali errori in json
                  // non vengono correttamente mappati, pertanto non si utilizza la funzione
                  // generica handleError ma si visualizza l'errore così com'è.
                  this.messageProvider.notifyError(error);
              });
  }
  
  downloadFile(data) 
  {
      let blob = new Blob([data], {  type: "application/vnd.ms-excel" });
      let file = "StatisticheMensili_" + (this.monthSelected + 1) + "_" + this.yearSelected; 
      FileSaver.saveAs(blob, file + ".xlsx");
   }


      isVisibile(id: number): boolean{
        let result = false;
        let utente = this.users.find(user => user.id === id);
        if((this.selectedGruppo==0 && this.getGruppoUser(utente)!=null) || (this.gruppi[this.selectedGruppo] != null && this.getGruppoUser(utente) === this.gruppi[this.selectedGruppo].label)){
            result=true;
            }
        return result;
      }

      getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
        
        const managedUsersMap = this.userInfo.managedUsersMap;
        
        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/app/users-prospect/users-prospect.component.ts